module.exports = __webpack_public_path__ + "img/index-top1.75b74f03.png";